/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CharityAccountBalanceDto } from '../models/CharityAccountBalanceDto';
import type { CharityDto } from '../models/CharityDto';
import type { CharityStatsDto } from '../models/CharityStatsDto';
import type { CreateCharityWithUserDto } from '../models/CreateCharityWithUserDto';
import type { UpdateCharityDto } from '../models/UpdateCharityDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class CharitiesService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Create new charity entity
     * @param requestBody Data for creating a charity with user
     * @returns CharityDto The charity has been successfully created.
     * @throws ApiError
     */
    public charitiesControllerCreate(
        requestBody: CreateCharityWithUserDto,
    ): Observable<CharityDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/charities/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data.`,
            },
        });
    }
    /**
     * Get statistics for all charities
     * @returns CharityStatsDto Statistics for all charities retrieved successfully.
     * @throws ApiError
     */
    public charitiesControllerGetAllCharitiesStats(): Observable<Array<CharityStatsDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/charities/stats',
            errors: {
                403: `Access denied.`,
            },
        });
    }
    /**
     * Get a charity by ID
     * @param id The UUID of the charity
     * @returns CharityDto The charity details.
     * @throws ApiError
     */
    public charitiesControllerGetCharity(
        id: string,
    ): Observable<CharityDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/charities/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Charity not found.`,
            },
        });
    }
    /**
     * Update a charity
     * @param id The UUID of the charity to update
     * @param requestBody Data for updating the charity
     * @returns CharityDto The charity has been successfully updated.
     * @throws ApiError
     */
    public charitiesControllerUpdateCharity(
        id: string,
        requestBody: UpdateCharityDto,
    ): Observable<CharityDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/charities/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Access denied.`,
                404: `Charity not found.`,
            },
        });
    }
    /**
     * Delete a charity
     * @param id The UUID of the charity to delete
     * @returns void
     * @throws ApiError
     */
    public charitiesControllerDeleteCharity(
        id: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/charities/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Charity not found.`,
            },
        });
    }
    /**
     * Get all charity data filtered
     * @param page
     * @param limit
     * @param sortActive
     * @param sortDirection
     * @param filter
     * @param statuses
     * @param roles
     * @returns any List of charities retrieved successfully.
     * @throws ApiError
     */
    public charitiesControllerGetCharities(
        page: number,
        limit: number,
        sortActive: string,
        sortDirection: string,
        filter: string,
        statuses: Array<string>,
        roles: Array<string>,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/charities',
            query: {
                'page': page,
                'limit': limit,
                'sortActive': sortActive,
                'sortDirection': sortDirection,
                'filter': filter,
                'statuses': statuses,
                'roles': roles,
            },
            errors: {
                403: `Access denied.`,
            },
        });
    }
    /**
     * Get statistics for a specific charity
     * @param id The UUID of the charity
     * @returns CharityStatsDto Statistics for the charity retrieved successfully.
     * @throws ApiError
     */
    public charitiesControllerGetCharityStats(
        id: string,
    ): Observable<CharityStatsDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/charities/{id}/stats',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Charity not found.`,
            },
        });
    }
    /**
     * Get a charity account balance by charityID
     * @param id The UUID of the charity
     * @returns CharityAccountBalanceDto The charity details.
     * @throws ApiError
     */
    public charitiesControllerGetCharityAccountBalance(
        id: string,
    ): Observable<CharityAccountBalanceDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/charities/{id}/balance',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Charity not found.`,
            },
        });
    }
}
